import digiDesign from "../assets/images/digiplus.png";
import ficasDesign from "../assets/images/ficas.png";

import BigData from "../assets/images/BigData.jpeg";
import ObjectDetection from "../assets/images/ObjectDetection.webp";
import ImageCaptioning from "../assets/images/captiongenerator.gif";
import ElectricityConsumptionForecast from "../assets/images/ElectricityConsumptionForecast.jpg";

import blogImage2 from "../assets/images/blog-image-2.jpg";
import blogImage6 from "../assets/images/blog-image-6.jpg";
import blogImage7 from "../assets/images/AboutImg.jpg";

const fa = {
  locale: "fa",

  name: "مهدی طالبی",
  navRole: "مهندس هوش مصنوعی",
  openNavigation: "باز کردن منو",
  dayMode: "حالت روز",
  darkMode: "حالت شب",

  home: "صفحه اصلی",
  about: "درباره من",
  resume: "رزومه",
  portfolio: "پروژه‌ها",
  blog: "نوشته‌ها",
  contact: "ارتباط با من",

  hi: "سلام، من ",
  hi2: " هستم",

  homeKicker: "هوش مصنوعی کاربردی · یادگیری ماشین · مهندسی نرم‌افزار",
  homeHeadline: "سیستم‌های هوشمندی می‌سازم که پژوهش را به محصول واقعی وصل می‌کنند.",
  desc:
    "در حوزه هوش مصنوعی کاربردی، یادگیری ماشین، بینایی کامپیوتر و مهندسی نرم‌افزار فعالیت می‌کنم. تجربه من از پژوهش در ردیابی چند شی و ادراک خودروهای خودران تا ساخت سیستم‌های پیشنهاد محصول، رتبه‌بندی، جست‌وجوی شباهت تصویری، کشف هوشمند محصول و ابزارهای مبتنی بر AI برای کسب‌وکار را شامل می‌شود.",

  homeProofTitle: "حوزه‌های اصلی کار من",
  homeProofLead: "سه محور اصلی که پژوهش و تجربه حرفه‌ای فعلی من را بهتر از بقیه توضیح می‌دهند.",

  homeSignals: [
    "پژوهش — SNN + BLS، ردیابی چند شی، ادراک خودروهای خودران و دیتاست KITTI.",
    "هوش مصنوعی کاربردی — پیشنهاددهی، رتبه‌بندی، شخصی‌سازی، جست‌وجوی تصویری و کشف هوشمند محصول.",
    "مهندسی — Python، React، API، جریان‌های داده، سیستم‌های تجارت الکترونیک و نرم‌افزارهای عملیاتی وب.",
  ],

  viewProjects: "مشاهده پروژه‌ها",
  downloadcv: "دانلود رزومه",

  aboutme: "درباره من",
  aboutEyebrow: "معرفی",
  aboutDescription:
    "در مرز میان هوش مصنوعی کاربردی، بینایی کامپیوتر، یادگیری ماشین و مهندسی نرم‌افزار کار می‌کنم. مسیر حرفه‌ای من ترکیبی از پژوهش و ساخت محصول است؛ از ردیابی چند شی و ادراک خودروهای خودران گرفته تا سیستم‌های پیشنهاددهنده، جست‌وجوی شباهت بصری، کشف هوشمند محصول، دستیارهای هوشمند و نرم‌افزارهایی که در فرایندهای واقعی کسب‌وکار استفاده می‌شوند. برای من کیفیت مهندسی، قابلیت نگهداری و کاربرد واقعی یک سیستم به اندازه خود مدل اهمیت دارد.",
  aboutJourney:
    "مسیر دانشگاهی من با کارشناسی مهندسی نساجی در دانشگاه صنعتی امیرکبیر شروع شد. بعد از آن با تغییر مسیر به مهندسی کامپیوتر، کارشناسی ارشد علم داده را در دانشگاه شهید بهشتی با تمرکز پژوهشی روی هوش مصنوعی و بینایی کامپیوتر به پایان رساندم.",
  aboutImageAlt: "محیط کاری مرتبط با هوش مصنوعی و مهندسی نرم‌افزار",
  aboutFocusTags: [
    "هوش مصنوعی کاربردی",
    "یادگیری ماشین",
    "بینایی کامپیوتر",
    "سیستم‌های پیشنهاددهنده",
    "جست‌وجوی هوشمند",
    "مهندسی نرم‌افزار",
  ],

  coreAreasTitle: "حوزه‌های اصلی فعالیت",
  coreAreasEyebrow: "تمرکز حرفه‌ای",
  coreAreas: [
    {
      id: "ai",
      icon: "ai",
      title: "هوش مصنوعی کاربردی و یادگیری ماشین",
      desc:
        "طراحی قابلیت‌های هوشمند برای مسائل واقعی محصول و کسب‌وکار؛ شامل پیشنهاددهی، رتبه‌بندی، شخصی‌سازی، جست‌وجوی هوشمند و تصمیم‌گیری مبتنی بر داده.",
    },
    {
      id: "cv",
      icon: "cv",
      title: "بینایی کامپیوتر و ادراک هوشمند",
      desc:
        "پژوهش و توسعه در تشخیص اشیا، ردیابی چند شی، جست‌وجوی شباهت بصری، مدل‌سازی زمانی و ادراک در سیستم‌های خودران.",
    },
    {
      id: "software",
      icon: "software",
      title: "مهندسی نرم‌افزار و محصول",
      desc:
        "ساخت نرم‌افزارهای کاربردی پیرامون سیستم‌های هوش مصنوعی با Python، JavaScript، React، API، پایگاه داده و جریان‌های عملیاتی وب و تجارت الکترونیک.",
    },
  ],

  fullname: "نام و نام خانوادگی",
  age: "سن",
  languages: "زبان‌ها",
  address: "موقعیت",
  phone: "شماره تماس",
  availabilityLabel: "وضعیت همکاری",
  persian: "فارسی",
  english: "انگلیسی",
  street: "تهران، ایران",
  available: "آماده بررسی فرصت‌های مرتبط با هوش مصنوعی و مهندسی",
  tel: "۰۹۳۵۹۷۳۲۲۶۴",

  resumePageTitle: "رزومه",
  resumeEyebrow: "تجربه و تحصیلات",
  workingexperience: "سوابق حرفه‌ای",

  workingSteps: [
    {
      id: "petro-nour-mehr",
      date: "آذر ۱۴۰۲ - اکنون",
      title: "مدیر فناوری هوش مصنوعی و وب",
      subtitle: "شرکت بین‌المللی پترو نور مهر · تمام‌وقت",
      meta: "حضوری",
      content:
        "طراحی و توسعه سیستم‌های محصول و کسب‌وکار مبتنی بر هوش مصنوعی برای یک شرکت B2B پتروشیمی.",
      highlights: [
        "ساخت دستیار هوشمند مبتنی بر پایگاه دانش برای پاسخ‌گویی به پرسش‌های مشتری با استفاده از اطلاعات منتخب شرکت و محصولات.",
        "توسعه جست‌وجو و کشف هوشمند محصول با اتصال داده‌های فنی کاتالوگ به محتوای تجاری وب‌سایت.",
        "اتصال هوش مصنوعی کاربردی، داده محصول، API و مهندسی وب به جریان‌های واقعی عملیاتی و تجاری.",
      ],
      skills: ["Artificial Intelligence (AI)", "Intelligent Search", "Product Discovery", "React", "APIs"],
      logo: "/logos/petro-nour-mehr.png",
      logoFallback: "PNM",
    },
    {
      id: "sbu-research",
      date: "آبان ۱۴۰۱ - آبان ۱۴۰۴",
      title: "دستیار پژوهشی در آزمایشگاه هوش مصنوعی و رباتیک",
      subtitle: "دانشگاه شهید بهشتی",
      meta: "استان تهران، ایران · حضوری",
      content:
        "پژوهش در حوزه بینایی کامپیوتر، یادگیری عمیق، خودروهای خودران و ردیابی چند شی.",
      highlights: [
        "طراحی و ارزیابی معماری ترکیبی شبکه‌های عصبی ضربه‌ای (SNN) و سیستم یادگیری گسترده (BLS) برای ردیابی چند شی.",
        "کار با استخراج ویژگی زمانی-مکانی، توسعه ویژگی عصبی، کدگذاری زمانی و Track Association کلاسیک روی KITTI.",
      ],
      skills: ["Machine Learning Algorithms", "System Configuration", "Computer Vision", "Deep Learning", "Multi-Object Tracking"],
      logo: "/logos/shahid-beheshti-university.jpg",
      logoFallback: "SBU",
    },
    {
      id: "digikala",
      date: "اسفند ۱۳۹۹ - دی ۱۴۰۰ · ۱۱ ماه",
      title: "توسعه‌دهنده فرانت‌اند وب",
      subtitle: "Digikala.com · تمام‌وقت",
      meta: "استان تهران، ایران",
      content:
        "مشارکت در توسعه فرانت‌اند یک پلتفرم بزرگ تجارت الکترونیک و محیط وب Production.",
      highlights: [
        "ساخت و نگهداری رابط‌های کاربری در یک محیط عملیاتی تجارت الکترونیک.",
        "کار روی پیاده‌سازی ماژولار، مقیاس‌پذیر و نگهداری‌پذیر برای تجربه‌های وب پرترافیک.",
      ],
      skills: ["JavaScript", "Node.js", "React", "Frontend Engineering", "E-commerce"],
      logo: "/logos/digikala.png",
      logoFallback: "DK",
    },
    {
      id: "ficas",
      date: "اسفند ۱۳۹۸ - آذر ۱۳۹۹ · ۱۰ ماه",
      title: "توسعه‌دهنده فرانت‌اند وب",
      subtitle: "FiCAS AG · تمام‌وقت",
      meta: "سوئیس",
      content:
        "همکاری نزدیک با تیم‌های چندتخصصی شامل طراحان، توسعه‌دهندگان بک‌اند و مدیران محصول.",
      highlights: [
        "کمک به تعریف دقیق نیازمندی‌های فرانت‌اند و پیاده‌سازی کارآمد آن‌ها.",
        "مشارکت در توسعه فرانت‌اند و مدیریت وب‌سایت یک شرکت سوئیسی در حوزه سرمایه‌گذاری و دارایی دیجیتال.",
      ],
      skills: ["JavaScript", "Web Development", "Frontend Development", "Responsive Design", "UI Engineering"],
      logo: "/logos/ficas.png",
      logoFallback: "FC",
    },
    {
      id: "pars-shir",
      date: "شهریور ۱۳۹۶ - شهریور ۱۳۹۸ · ۲ سال و ۱ ماه",
      title: "توسعه‌دهنده فول‌استک",
      subtitle: "pars-shir.com · تمام‌وقت",
      meta: "استان تهران، ایران",
      content:
        "طراحی، توسعه و نگهداری وب‌اپلیکیشن‌ها از هر دو سمت فرانت‌اند و بک‌اند.",
      highlights: [
        "مسئولیت طراحی و توسعه رابط کاربری وب‌اپلیکیشن شرکت با استفاده از فناوری‌های مدرن وب.",
        "فعالیت هم‌زمان در فرانت‌اند، بک‌اند و نگهداری وب‌سایت یک مجموعه صنعتی.",
      ],
      skills: ["Full-stack Development", "JavaScript", "Web Development", "Frontend", "Backend"],
      logo: "/logos/pars-shir.png",
      logoWide: true,
      logoFallback: "PS",
    },
  ],

  educationalqualifications: "تحصیلات",
  educationalSteps: [
    {
      id: 1,
      date: "مهر ۱۴۰۱ - مهر ۱۴۰۴",
      title: "کارشناسی ارشد علم داده — مهندسی کامپیوتر",
      subtitle: "دانشگاه شهید بهشتی — دانشکده مهندسی و علوم کامپیوتر",
      content:
        "تمرکز تحصیلی و پژوهشی بر یادگیری ماشین، بینایی کامپیوتر، سیستم‌های هوشمند و ادراک خودروهای خودران. پایان‌نامه در مهر ۱۴۰۴ دفاع شد.",
      highlights: [
        "تمرکز پژوهشی بر بینایی کامپیوتر، ادراک خودروهای خودران، ردیابی چند شی و سیستم‌های عصبی کارآمد.",
      ],
      skills: ["Data Science", "Machine Learning", "Computer Vision", "Research"],
      logo: "/logos/shahid-beheshti-university.jpg",
      logoFallback: "SBU",
    },
    {
      id: 2,
      date: "مهر ۱۳۹۴ - بهمن ۱۳۹۹",
      title: "کارشناسی مهندسی نساجی",
      subtitle: "دانشگاه صنعتی امیرکبیر — پلی‌تکنیک تهران",
      content:
        "پس از پایان دوره کارشناسی مهندسی، مسیر تحصیلی و حرفه‌ای خود را به سمت مهندسی کامپیوتر، علم داده و هوش مصنوعی تغییر دادم.",
      highlights: [
        "ایجاد پایه مهندسی و تحلیلی قوی پیش از ورود تخصصی به نرم‌افزار، علم داده و هوش مصنوعی.",
      ],
      skills: ["Engineering", "Analytical Thinking", "Problem Solving"],
      logo: "/logos/amirkabir-university.png",
      logoFallback: "AUT",
    },
  ],

  certificationsTitle: "گواهی‌ها و دوره‌های تخصصی",
  credentialIdLabel: "شناسه گواهی",
  showCredential: "مشاهده گواهی",
  certifications: [
    {
      id: "deeplearning-ai-ml",
      title: "Machine Learning",
      issuer: "DeepLearning.AI",
      date: "صادرشده در آوریل ۲۰۲۴",
      credentialId: "58K5Y7JDJ3AV",
      skills: ["Machine Learning", "Supervised Learning"],
      logo: "/logos/deeplearning-ai.png",
      logoFallback: "DL",
      href: "",
    },
    {
      id: "hermes-ds-bootcamp",
      title: "Data Science & Machine learning bootcamp",
      issuer: "Hermes Capital | هرمس کپیتال",
      date: "صادرشده در سپتامبر ۲۰۲۲",
      credentialId: "",
      skills: ["Machine Learning", "Data Science"],
      logo: "/logos/hermes-capital.png",
      logoFallback: "HC",
      href: "",
    },
    {
      id: "ut-cwp",
      title: "Master Certified Web Professional - Designer (CWP)",
      issuer: "دانشگاه تهران",
      date: "صادرشده در اکتبر ۲۰۱۸",
      credentialId: "",
      skills: ["Web Design", "Web Development"],
      logo: "/logos/university-tehran.png",
      logoFallback: "UT",
      href: "",
    },
  ],

  researchSpotlight: "پژوهش شاخص",
  researchTitle: "ادغام شبکه عصبی ضربه‌ای و سیستم یادگیری گسترده برای ردیابی چند شی",
  researchDescription:
    "در پایان‌نامه کارشناسی ارشد، یک معماری ترکیبی SNN–BLS برای ردیابی چند شی در سناریوهای خودروهای خودران بررسی و پیاده‌سازی شد. این سیستم از استخراج ویژگی مبتنی بر MobileNetV3/FPN، توسعه ویژگی با Broad Learning System، لایه‌های اسپایکی مبتنی بر نورون‌های LIF و اتصال Trackها با Kalman Filter و Hungarian Algorithm استفاده می‌کند و روی KITTI ارزیابی شده است.",
  researchTags: [
    "Spiking Neural Networks",
    "Broad Learning System",
    "Multi-Object Tracking",
    "KITTI",
    "Autonomous Driving",
    "Computer Vision",
  ],
  researchStats: [
    { value: "۷۷٫۹۳", label: "HOTA روی بخش ارزیابی داخلی KITTI" },
    { value: "کمتر از ۲۷ ms", label: "زمان پردازش انتها به انتهای هر فریم روی NVIDIA A100" },
    { value: "حدود ۹٫۲٪", label: "میزان فعالیت اسپایک گزارش‌شده در معماری پیشنهادی" },
    { value: "KITTI", label: "دیتاست مورد استفاده برای ارزیابی خودروهای خودران" },
  ],

  myskills: "توانمندی‌های فنی",
  skillGroups: [
    {
      title: "هوش مصنوعی کاربردی و یادگیری ماشین",
      items: [
        "یادگیری ماشین",
        "یادگیری عمیق",
        "سیستم‌های پیشنهاددهنده",
        "سیستم‌های رتبه‌بندی",
        "شخصی‌سازی",
        "جست‌وجوی هوشمند",
        "جست‌وجوی شباهت بصری",
        "تحلیل داده",
      ],
    },
    {
      title: "بینایی کامپیوتر و پژوهش",
      items: [
        "Computer Vision",
        "Multi-Object Tracking",
        "Object Detection",
        "Re-Identification",
        "Spiking Neural Networks",
        "Broad Learning Systems",
        "Temporal Modeling",
        "OpenCV",
      ],
    },
    {
      title: "مهندسی هوش مصنوعی و داده",
      items: [
        "Python",
        "PyTorch",
        "TensorFlow",
        "Keras",
        "Scikit-learn",
        "NumPy",
        "pandas",
        "SQL",
      ],
    },
    {
      title: "مهندسی نرم‌افزار و محصول",
      items: [
        "JavaScript",
        "React",
        "Node.js",
        "REST APIs",
        "WordPress",
        "WooCommerce",
        "PHP",
        "MySQL",
      ],
    },
  ],

  portfolioEyebrow: "نمونه کار منتخب",
  portfolioLead:
    "منتخبی از پژوهش‌ها، سیستم‌های هوش مصنوعی کاربردی و پروژه‌های نرم‌افزاری من؛ با تمرکز بر مسئله فنی، آنچه پیاده‌سازی شده و ارتباط آن با یک کاربرد واقعی.",
  featuredWork: "پروژه‌های شاخص",
  selectedAIProjects: "پروژه‌های منتخب هوش مصنوعی و یادگیری ماشین",
  frontend: "سوابق و پروژه‌های پیشین مهندسی وب",
  visitProject: "مشاهده پروژه",

  autonomousVisual: {
    car: "خودرو ۰٫۹۶",
    pedestrian: "عابر ۰٫۹۱",
    bus: "اتوبوس ۰٫۹۳",
    tracking: "ردیابی چند شی",
    perception: "ادراک فعال",
  },

  featuredProjects: [
    {
      id: "javert",
      type: "هوش مصنوعی کاربردی · تجارت الکترونیک",
      title: "ژاور — سیستم‌های هوشمند تجارت و عملیات فروشگاه",
      desc:
        "طراحی و توسعه مجموعه‌ای از قابلیت‌های هوشمند برای یک کسب‌وکار واقعی پوشاک مردانه؛ شامل رتبه‌بندی چندمعیاره محصول، پیشنهاد ست هوشمند، راهنمای شخصی‌سازی‌شده سایز، جست‌وجوی شباهت بصری، مدیریت ست‌ها و ابزارهای عملیاتی مدیریت موجودی و قیمت همراه با اعلان‌های تلگرامی سفارش و موجودی.",
      tags: ["Recommendation", "Ranking", "Visual Search", "Personalization", "WooCommerce"],
      metrics: [
        "امتیازدهی براساس فروش، محبوبیت، موجودی و سایزبندی",
        "تطبیق رنگ، فصل، قواره و سازگاری ست",
        "اتوماسیون موجودی و سفارش در تلگرام",
      ],
      href: "https://javert.store",
      domain: "javert.store",
      media: ["/project-shots/javert.webp", "/project-shots/javert.png", "/project-shots/javert.gif", "/project-shots/javert.jpg"],
      imageAlt: "صفحه اصلی فروشگاه ژاور",
      visualLabel: "JAVERT",
    },
    {
      id: "petro",
      type: "هوش مصنوعی کاربردی · B2B",
      title: "پترو نور مهر — دستیار هوشمند و جست‌وجوی محصول",
      desc:
        "توسعه قابلیت‌های مبتنی بر هوش مصنوعی برای کشف محصول در یک کسب‌وکار B2B پتروشیمی؛ شامل دستیار دانش‌محور مشتری و جست‌وجوی هوشمند در اطلاعات فنی محصولات و محتوای تجاری وب‌سایت.",
      tags: ["AI Assistant", "Knowledge Base", "Product Search", "B2B", "Web Engineering"],
      metrics: ["پاسخ‌گویی مبتنی بر دانش محصول", "کشف هوشمند محصولات"],
      href: "https://petronourmehr.com",
      domain: "petronourmehr.com",
      media: ["/project-shots/petronourmehr.webp", "/project-shots/petronourmehr.png", "/project-shots/petronourmehr.gif", "/project-shots/petronourmehr.jpg"],
      imageAlt: "صفحه اصلی پترو نور مهر",
      visualLabel: "PNM · AI",
    },
    {
      id: "research",
      type: "پژوهش · بینایی کامپیوتر",
      title: "SNN + BLS برای ردیابی چند شی در خودروهای خودران",
      desc:
        "پژوهش کارشناسی ارشد درباره ترکیب شبکه‌های عصبی ضربه‌ای با سیستم‌های یادگیری گسترده برای ردیابی چند شی روی KITTI و ترکیب استخراج ویژگی زمانی-مکانی، توسعه ویژگی عصبی و Track Association کلاسیک.",
      tags: ["SNN", "BLS", "KITTI", "Multi-Object Tracking", "Autonomous Driving"],
      metrics: ["HOTA = ۷۷٫۹۳", "کمتر از ۲۷ ms/frame", "حدود ۹٫۲٪ فعالیت اسپایک"],
      href: "",
      domain: "پژوهش کارشناسی ارشد · KITTI",
      media: ["/project-shots/thesis-autonomous-driving.webp", "/project-shots/thesis-autonomous-driving.png"],
      imageAlt: "نمایی از پژوهش ردیابی چند شی",
      visualLabel: "SNN × BLS",
    },
  ],

  portfoliosmlList: [
    {
      id: "intrusion",
      href: "",
      title: "تشخیص نفوذ در شبکه",
      desc: "تحلیل و پیاده‌سازی روش‌های یادگیری ماشین برای تشخیص حملات نفوذ در داده‌های شبکه.",
      image: BigData,
    },
    {
      id: "yolov8",
      href: "",
      title: "تشخیص اشیا با YOLOv8",
      desc: "پیاده‌سازی سیستم تشخیص اشیا با YOLOv8 و ارائه آن در قالب یک وب‌اپلیکیشن تعاملی مبتنی بر Streamlit.",
      image: ObjectDetection,
    },
    {
      id: "captioning",
      href: "",
      title: "تولید خودکار شرح تصویر",
      desc: "تولید و ارزیابی شرح تصویر با استفاده از CNN و LSTM روی دیتاست Flickr8k.",
      image: ImageCaptioning,
    },
    {
      id: "forecasting",
      href: "",
      title: "پیش‌بینی مصرف برق",
      desc: "پیش‌بینی سری زمانی مصرف برق با استفاده از شبکه‌های عصبی بازگشتی و LSTM.",
      image: ElectricityConsumptionForecast,
    },
  ],

  portfoliosList: [
    {
      id: "digikala",
      href: "https://digikala.com",
      title: "دیجی‌کالا",
      desc: "تجربه توسعه فرانت‌اند در یک پلتفرم بزرگ تجارت الکترونیک و رابط‌های کاربری عملیاتی مبتنی بر React.",
      image: digiDesign,
    },
    {
      id: "ficas",
      href: "https://ficas.com",
      title: "Ficas",
      desc: "تجربه توسعه فرانت‌اند و مدیریت وب‌سایت برای یک مجموعه سرمایه‌گذاری و دارایی دیجیتال در سوئیس.",
      image: ficasDesign,
    },
    {
      id: "parsshir",
      href: "https://www.pars-shir.com/",
      title: "پارس شیر",
      desc: "تجربه توسعه فرانت‌اند و بک‌اند وب‌سایت یک مجموعه صنعتی.",
      image: "/logos/pars-shir.png",
    },
  ],

  writingPageTitle: "نوشته‌ها و مطالعه",
  writingEyebrow: "علایق فنی",
  writingIntroTitle: "مطالعه‌های منتخب فنی",
  writingLead:
    "در این صفحه منابعی را نگه می‌دارم که به حوزه‌های پژوهشی و مهندسی مورد علاقه من نزدیک‌اند؛ به‌ویژه رایانش نورومورفیک، شبکه‌های عصبی ضربه‌ای، ادراک هوشمند و سیستم‌های هوش مصنوعی کاربردی.",
  writingDisclosure: "مقاله‌های زیر منابع خارجی هستند و به‌عنوان مقاله تألیفی من معرفی نمی‌شوند.",
  writingTopics: ["Spiking Neural Networks", "Neuromorphic Computing", "Computer Vision", "Applied AI"],
  readArticle: "مطالعه در منبع اصلی",

  blogsList: [
    {
      id: "ieee-neuromorphic-big-time",
      href: "https://spectrum.ieee.org/neuromorphic-computing-2671121824",
      title: "رایانش الهام‌گرفته از مغز در آستانه کاربردهای بزرگ‌تر",
      desc:
        "IEEE Spectrum درباره حرکت رایانش نورومورفیک از نمونه‌های پژوهشی به سمت سیستم‌های بزرگ‌تر و نقش شبکه‌های عصبی ضربه‌ای در این مسیر صحبت می‌کند.",
      source: "IEEE Spectrum",
      readTime: "۶ دقیقه",
      tags: ["Neuromorphic Computing", "SNN", "AI Hardware"],
      image: blogImage6,
    },
    {
      id: "ieee-spinnaker2",
      href: "https://spectrum.ieee.org/neuromorphic-computing-spinnaker2",
      title: "SpiNNaker2 و مقیاس‌پذیری رایانش نورومورفیک",
      desc:
        "مروری کوتاه بر SpiNNaker2، پردازش رویدادمحور، مقیاس بزرگ سیستم‌های نورومورفیک و مصالحه‌های مهندسی در طراحی سامانه‌های الهام‌گرفته از مغز.",
      source: "IEEE Spectrum",
      readTime: "۳ دقیقه",
      tags: ["SpiNNaker2", "Neuromorphic Systems", "Parallel Computing"],
      image: blogImage2,
    },
    {
      id: "ieee-ai-hardware",
      href: "https://spectrum.ieee.org/ai-hardware",
      title: "سخت‌افزارهای الهام‌گرفته از مغز و شبکه‌های عصبی ضربه‌ای",
      desc:
        "گفت‌وگویی درباره شبکه‌های نورومورفیک ضربه‌ای، سخت‌افزار کم‌مصرف هوش مصنوعی و این پرسش که این معماری‌ها در چه مسائلی می‌توانند از روش‌های متعارف بهتر عمل کنند.",
      source: "IEEE Spectrum",
      readTime: "۵ دقیقه",
      tags: ["Spiking Networks", "AI Hardware", "Efficiency"],
      image: blogImage7,
    },
  ],

  contactme: "ارتباط با من",
  contactEyebrow: "تماس",
  getintouch: "در تماس باشیم",
  contactLead:
    "اگر برای یک پروژه هوش مصنوعی، فرصت مهندسی، همکاری پژوهشی یا توسعه محصول قصد ارتباط دارید، پیام خود را ارسال کنید تا در اولین فرصت پاسخ بدهم.",
  contactInfoTitle: "اطلاعات تماس",
  contactInfoLead: "از طریق اطلاعات زیر نیز می‌توانید مستقیماً با من در ارتباط باشید.",
  entername: "نام شما",
  enteremail: "ایمیل شما",
  entersubject: "موضوع",
  entermessage: "کمی درباره موضوع یا پروژه‌ای که در ذهن دارید بنویسید",
  sendmessage: "ارسال پیام",
  sending: "در حال ارسال...",
  messageSent: "پیام شما با موفقیت ارسال شد.",
  messageError: "ارسال پیام انجام نشد. دوباره تلاش کنید یا مستقیماً ایمیل بزنید.",
  email: "ایمیل",
};

export default fa;
